ACC.imagegallery = {

	_autoload: [
		"bindImageGallery"
	],

	bindImageGallery: function (){

		$(".js-gallery").each(function(){
			var $image = $(this).find(".js-gallery-image");
			var $carousel = $(this).find(".js-gallery-carousel")
			var imageTimeout;

			$image.owlCarousel({
				// singleItem : true,
				lazyLoad: false,
				items: 1,
				rewind: true,
				pagination: true,
				navText : ["<span class='glyphicon glyphicon-chevron-left'></span>", "<span class='glyphicon glyphicon-chevron-right'></span>"],
				responsive: {
					0: {
						dots: true,
						nav: false,
					},
					640: {
						dots: false,
						nav: false,
					},
					1024: {
						dots: false,
						nav: true,
					},
				},
				afterAction : function(){
					ACC.imagegallery.syncPosition($image,$carousel,this.currentItem)
					$image.data("zoomEnable",true)
				},
				startDragging: function(){
					$image.data("zoomEnable",false)
				},
				afterLazyLoad:function(e){
					var b = $image.data("owlCarousel") || {}

					if(!b.currentItem){
						b.currentItem = 0
					}

					var $e=$($image.find("img.lazyOwl")[b.currentItem]);
					startZoom($e.parent())
				}
			});

			$carousel.owlCarousel({
				nav:true,
				navText : ["<span class='glyphicon glyphicon-chevron-left'></span>", "<span class='glyphicon glyphicon-chevron-right'></span>"],
				dots:false,
				items:1,
				touchDrag: false,
				mouseDrag: false,
				responsive: {
					0: {
						items: 2,
					},
					640: {
						items: 4,
					},
					1024: {
						items: 4,
					}
				},
				lazyLoad:false,
				rewind: true,
				afterAction : function(){

				},
			});

			$carousel.on("click", "a.item",function(e){
				e.preventDefault();
				$image.trigger("to.owl.carousel", [$(this).parent(".owl-item").index(), 300]);
			})

			function startZoom(e) {
				$(e).zoom({
					url: $(e).find("img.lazyOwl").data("zoomImage"),
					touch: true,
					on: "grab",
					touchduration:300,

					onZoomIn:function(){

					},

					onZoomOut:function(){
						var owl = $image.data('owlCarousel');
						owl.dragging(true)
						$image.data("zoomEnable",true)
					},

					zoomEnableCallBack:function(){
						var bool = $image.data("zoomEnable")

						var owl = $image.data('owlCarousel');
						if(bool==false){
							owl.dragging(true)
						}
						else{

						 	owl.dragging(false)
						}
						return bool;
					}
				});
			}
		})
	},


	syncPosition: function($image,$carousel,currentItem){
		$carousel.trigger("owl.goTo",currentItem);
	}
};
